module.exports = __webpack_public_path__ + "static/media/navbar-interna.d6bd563f.png";